(function(window, angular, undefined) {
angular.module('formApp')
.service('dataUtils', ['$http', 'errorHandler', function($http, errorHandler) {

var productMap = [
{ 'productId': 'DVA', 'productTitle': '£3,000', 'productPlan': 'Essential Plan' },
{ 'productId': 'DCA', 'productTitle': '£4,000', 'productPlan': 'Covered For Life<sup>&reg;</sup> Plan' },
{ 'productId': 'DCB', 'productTitle': '£7,000', 'productPlan': 'Covered For Life<sup>&reg;</sup> Plan' },
{ 'productId': 'DCC', 'productTitle': '£12,000', 'productPlan': 'Covered For Life<sup>&reg;</sup> Plan' },
{ 'productId': 'CVA', 'productTitle': '£3,000', 'productPlan': 'Essential Plan' },
{ 'productId': 'CCA', 'productTitle': '£4,000', 'productPlan': 'Covered For Life<sup>&reg;</sup> Plan' },
{ 'productId': 'CCB', 'productTitle': '£7,000', 'productPlan': 'Covered For Life<sup>&reg;</sup> Plan' },
{ 'productId': 'CCC', 'productTitle': '£12,000', 'productPlan': 'Covered For Life<sup>&reg;</sup> Plan' },
{ 'productId': 'RCA', 'productTitle': '£4,000', 'productPlan': 'Rabbit Plan' }
];

var ipids = [];

function getProductTitle(id) {
if (!id) {
return '';
}
var prod = productMap.filter(function (prod) {
return id === prod.productId;
});
return prod[0].productTitle ? prod[0].productTitle : '';
}

function getProductPlan(id) {
if (!id) {
return '';
}
var prod = productMap.filter(function (prod) {
return id === prod.productId;
});
return prod[0].productPlan ? prod[0].productPlan : '';
}

function setProductMap(data) {
productMap = data;
}

function getIpids() {
if (!ipids.length) {
$http.get('/content/ah_small-animal/config/ipid/jcr:content/main/ipid_config/ipids.json').then(function(result) {
ipids = result.data.ipids.map(function(item) {
return JSON.parse(item);
});
}).catch(function(data) {
errorHandler.reportErrors(data,'redirect','ipid');
});
}
}

function getIpid(ipid) {
// console.log('ipid', ipid);
var doc = ipids.filter(function(item, index) {
return item.ipidId === ipid;
});
if (doc[0] && doc[0].ipidPath) {
return doc[0].ipidPath;
} else {
return "";
}
}

return  {
petNamesList: function(pets) {
var namesList;
if (pets.length === 1) {
namesList = pets[0];
}
else if (pets.length === 2) {
namesList = pets.join(' and ');
}
else if (pets.length === 3) {
var last = pets.pop();
namesList = pets.join(', ') + ' and ' + last;
}
else if (pets.length >= 4) {
namesList = 'your pet';
}
return namesList;

},

freeCoverChannel: function(prodId) {

var channel = 'vet';

if (prodId === 'PK') {
channel = 'breeder';
}
if (['CP','CY','NC','BX'].indexOf(prodId) !== -1) {
channel = 'rehoming centre';
}
if (['LL','TR'].indexOf(prodId) !== -1) {
channel = 'microchipper';
}

return channel;

},
setProductMap: setProductMap,
getProductPlan: getProductPlan,
getProductTitle: getProductTitle,
getIpids: getIpids,
getIpid: getIpid
};
}]);       
})(window, window.angular);